import { supplierIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";
import { CreateSupplierContactInput } from "./create-supplier";

const UpdateSupplierInput_ = z.object({
  supplierId: supplierIdFormat.schema,
  name: z.string().optional(),
  street1: z.string().nullable().optional(),
  street2: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  state: z.string().nullable().optional(),
  postalCode: z.string().nullable().optional(),
  country: z.string().nullable().optional(),
  phoneNumber: z.string().nullable().optional(),
  website: z.string().nullable().optional(),
  currency: z.string().nullable().optional(),
  productVendors: z.array(z.string()).optional(),
  leadTimeDays: z.number().nullable().optional(),
  contacts: z.array(CreateSupplierContactInput).optional(),
  defaultPoTemplateId: z.string().nullable().optional(),
});

export const UpdateSupplierInput: z.ZodType<UpdateSupplierInput> =
  UpdateSupplierInput_;
export interface UpdateSupplierInput
  extends z.infer<typeof UpdateSupplierInput_> {}

export const updateSupplier = {
  name: "updateSupplier" as const,
  input: UpdateSupplierInput,
  output: z.object({ success: z.boolean() }),
};
